import { render, staticRenderFns } from "./messege_done.vue?vue&type=template&id=092c385e&scoped=true"
import script from "./messege_done.vue?vue&type=script&lang=js"
export * from "./messege_done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092c385e",
  null
  
)

export default component.exports